import { ReactNode } from "react";

/**
 * Notification Component
 *
 * A simple notification component to display messages to the user.
 * It supports different variants for different types of messages.
 */

export function Notification({
  children,
  variant = "neutral",
  title,
}: NotificationProps) {
  return (
    <div className={`puts-notification puts-notification--${variant}`}>
      <div className="puts-notification__icon"></div>
      <div className="puts-notification__content">
        {title ? <div className="puts-notification__title">{title}</div> : null}
        <div className="puts-notification__body">{children}</div>
      </div>
    </div>
  );
}

type NotificationProps = {
  variant?: "neutral" | "info" | "success" | "yellow" | "danger";
  title?: string;
  children: ReactNode;
};
